import { useTheme } from "next-themes";
import type { FocusEvent } from "react";
import { toast, Toaster as Sonner, type ToasterProps } from "sonner";

// خطا تا بستن دستی می‌ماند؛ اپ‌ها toast را مستقیم از sonner می‌گیرند، پس پیش‌فرض یک‌بار همین‌جا گذاشته می‌شود
const showError = toast.error;
toast.error = (message, data) => showError(message, { duration: Infinity, ...data });

// Sonner زمان‌سنج را فقط با hover نگه می‌دارد؛ تمرکز صفحه‌کلید روی اعلان همان hover را شبیه‌سازی می‌کند
const hover = (event: FocusEvent<HTMLDivElement>, type: "mouseover" | "mouseout") =>
  event.target.closest("[data-sonner-toaster]")?.dispatchEvent(new MouseEvent(type, { bubbles: true }));

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <div
      className="contents"
      onFocus={(event) => hover(event, "mouseover")}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) hover(event, "mouseout");
      }}
    >
      <Sonner
        theme={theme as ToasterProps["theme"]}
        className="toaster group"
        duration={8000}
        closeButton
        customAriaLabel="اعلان‌ها (میان‌بر Alt+T)"
        toastOptions={{
          closeButtonAriaLabel: "بستن اعلان",
          // ۲۰×۲۰ پیش‌فرض Sonner کوچک‌تر از کف ۲۴ پیکسلیِ هدف لمسی است (WCAG 2.2 و
          // ایراد target-size لایت‌هاوس وقتی اعلانی روی صفحه باشد)
          classNames: { closeButton: "!size-6" },
        }}
        style={
          {
            "--normal-bg": "var(--popover)",
            "--normal-text": "var(--popover-foreground)",
            "--normal-border": "var(--border)",
          } as React.CSSProperties
        }
        {...props}
      />
    </div>
  );
};

export { Toaster };
